import { useTranslation } from "react-i18next";
import { ISUnderConstruction } from "./ISUnderConstruction";

export const UnderConstruction = () =>{
    const {t} = useTranslation("others")

    return <ISUnderConstruction title={t("underConstruction.title")!} error={t("underConstruction.text")!}/>
}